import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../services/auth.js';

export default function Confirm() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') ?? '');
  const [code, setCode] = useState('');
  const [err, setErr] = useState(null);
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      await auth.confirm({ email: email.trim(), code: code.trim() });
      nav('/signin');
    } catch (e2) { setErr(e2.message); }
    finally { setBusy(false); }
  }

  async function resend() {
    try { await auth.resendCode({ email: email.trim() }); setMsg('Code resent.'); }
    catch (e2) { setErr(e2.message); }
  }

  return (
    <div className="container-narrow page-auth">
      <span className="eyebrow">One more step</span>
      <h2 className="mt-8 mb-32">Confirm your email.</h2>
      <div className="card">
        <form onSubmit={onSubmit}>
          {err && <div className="alert error mb-18">{err}</div>}
          {msg && <div className="alert success mb-18">{msg}</div>}
          <div className="field">
            <label>Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="field">
            <label>6-digit code</label>
            <input required value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" maxLength={6} />
          </div>
          <button className="btn btn-primary btn-block" disabled={busy}>
            {busy ? 'Confirming…' : 'Confirm'}
          </button>
        </form>
        <div className="center mt-16">
          <button onClick={resend} className="btn btn-ghost btn-sm fs-12">Resend code</button>
        </div>
      </div>
      <p className="muted center mt-20">
        <Link to="/signin">← Back to sign in</Link>
      </p>
    </div>
  );
}
